import React, { useContext, forwardRef } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { ThemeContext } from "../Theme";
import { Image, ImagePropTypes } from "../Image";

import TeaserHeading from "./TeaserHeading";
import TeaserCopyText from "./TeaserCopyText";
import TeaserButton from "./TeaserButton";

import styles from "./TextImageTeaser.scss";

export const TextImageTeaser = forwardRef(
  (
    {
      children,
      customClass,
      reverse,
      imgProps,
      contentProps,
      contentCustomClass,
      ...props
    },
    ref
  ) => {
    const theme = useContext(ThemeContext);
    const wrapperClasses = cx(
      styles.wrapper,
      {
        [styles["wrapper--reverse"]]: reverse,
        [styles[theme]]: theme,
      },
      customClass
    );

    return (
      <div className={wrapperClasses} ref={ref} {...props}>
        <div className={styles.imageWrapper}>
          {/* eslint-disable-next-line jsx-a11y/alt-text */}
          <Image customClass={styles.image} {...imgProps} />
        </div>
        <div
          className={cx(styles.content, contentCustomClass)}
          {...contentProps}
        >
          {children}
        </div>
      </div>
    );
  }
);

TextImageTeaser.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  customClass: PropTypes.string,
  contentCustomClass: PropTypes.string,
  reverse: PropTypes.bool,
  imgProps: PropTypes.shape(ImagePropTypes).isRequired,
  contentProps: PropTypes.objectOf(PropTypes.any),
};

TextImageTeaser.defaultProps = {
  children: null,
  customClass: undefined,
  contentCustomClass: undefined,
  reverse: false,
  contentProps: null,
};

TextImageTeaser.Heading = TeaserHeading;
TextImageTeaser.CopyText = TeaserCopyText;
TextImageTeaser.Button = TeaserButton;

TextImageTeaser.displayName = "TextImageTeaser";

export default TextImageTeaser;
